import { useState } from "react";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

export default function SearchBar({ handleFormSubmit }) {
  const [term, setTerm] = useState("");
  return (
    <form
      className="search-field"
      role="search"
      onSubmit={(event) => {
        event.preventDefault();
        if (term.trim()) handleFormSubmit(term.trim());
      }}
    >
      <input
        aria-label="Search courses"
        placeholder="What do you want to learn?"
        value={term}
        onChange={(event) => setTerm(event.target.value)}
      />
      <button type="submit" aria-label="Search">
        <MagnifyingGlassIcon />
      </button>
    </form>
  );
}
